import { FxConverterCard } from '@contexts/FxConverter/components/FxConverterCard'

export const Home = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
      <FxConverterCard />
    </div>
  )
}
